import { OpenAPI as OpenAPIv3_0 } from '@criteria/openapi/v3.0'
import { OpenAPI as OpenAPIv3_1 } from '@criteria/openapi/v3.1'

export type OpenAPI = OpenAPIv3_0<never> | OpenAPIv3_1<never>

export abstract class Change {
  abstract apply(document: OpenAPI): void
}
